import React from "react";

import styles from "./Input.module.scss";
import classNames from "classnames";

export const Input = (props: React.PropsWithChildren<{ style?: React.CSSProperties; className?: string }>) => {
  return (
    <div className={classNames(styles.root, props.className)} style={props.style}>
      {props.children}
    </div>
  );
};
